import { useRendererModal } from '@healthnz-prm/fhir-engine-renderer'
import type { CommonInputProps } from '@healthnz-prm/fhir-engine-renderer/types'
import { Link04Icon, LinkSquare02Icon } from '@hugeicons/core-free-icons'

function useAdditionalLabelProperties({
  label,
  labelComponent,
  required,
  supportLink,
  supportModal
}: Partial<CommonInputProps<any>>) {
  const { openModal, modalExists } = useRendererModal()

  let tertiaryLabelProps

  if (supportLink) {
    tertiaryLabelProps = {
      href: supportLink,
      tertiaryLabelIcon: Link04Icon
    }
  }

  if (supportModal && modalExists(supportModal)) {
    tertiaryLabelProps = {
      onTertiaryLabelClick: () => openModal(supportModal),
      tertiaryLabelIcon: LinkSquare02Icon
    }
  }

  return {
    ...tertiaryLabelProps,
    label: (labelComponent ?? label ?? '') as string,
    labelComponent,
    required
  }
}

export { useAdditionalLabelProperties }
